import React, { Component } from 'react';
import Modal from "../../../components/Modal/";

import './my-students.less';


class BulkDeleteChildModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lengthOfSelected: -1
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open && !(prevProps.open)) {
      this.setState({
        lengthOfSelected: this.props.lengthOfSelected
      })
    }
  }

  //////////////////////////////////

  render () {
    let titleText = "Delete ";
    if (this.props.lengthOfSelected === 1) {
      titleText += 1 + ' ' + this.props.yourX.singular;
    } else {
      titleText += this.props.lengthOfSelected + ' ' + this.props.yourX.plural;
    }
    const referenceToDelete = (this.state.lengthOfSelected > 1) ? 'them' : ('this ' + this.props.yourX.singular);

    return (
      <Modal className="edit-child-modal bulk-delete" open={this.props.open} onClose={this.props.closeBulkDeleteChildModal}>
        <div className="title">{titleText}</div>
        <div className="modal-inner">
          <div className="bulk-delete-note-to-user">
            <p>Are you sure you want to delete {referenceToDelete} from your list?</p>
            <p className="warning"><i className="icon-attention-circled"></i> This action cannot be undone.</p>
          </div>

          <div className="btn-container">
            <button type="button" className="btn btn-tertiary" onClick={()=>this.props.closeBulkDeleteChildModal()}>No, take me back</button>
            <button type="button" className="btn btn-destructive" onClick={()=>this.props.deleteBulkChildCallback()}>Yes, delete</button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default BulkDeleteChildModal;
